import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_SCORE_HISTORY_HANDLER = {
  topic: TOPIC_NAMES.OPEN_SCORE_HISTORY,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/ScoreHistory')
};